<template>
  <div class="c--partner-with-us_breadcrumb new-container mx-auto">
    <div class="partner-with-us-breadcrumb display-none display-md-grid">
      <div
        v-for="(breadcrumb, index) in breadcrumbs"
        :key="`partner-with-us-breadcrumb-${index}`"
        class="partner-with-us-breadcrumb-item"
      >
        <component
          :to="localePath(breadcrumb.link)"
          :target="breadcrumb.external ? '_blank' : '_self'"
          :is="breadcrumb.link ? 'nuxt-link' : 'p'"
        >
          {{ breadcrumb.title }}
        </component>

        <a-icon
          v-if="index !== breadcrumbs.length - 1"
          type="image"
          loader="data"
          name="icon-partner-with-us-breadcrumb-arrow"
          width="18"
        />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'breadcrumb',

    props: ['breadcrumbs'],
  }
</script>

<style lang="scss" scoped>
  .partner-with-us-breadcrumb {
    margin: 40px 0;
    grid-auto-flow: column;
    align-items: center;
    justify-content: flex-start;

    .partner-with-us-breadcrumb-item {
      display: flex;
      align-items: center;

      p,
      a {
        color: #8a8a8a;
        font-size: 13px;
        letter-spacing: 0;
        line-height: 18px;
        margin-bottom: 0;
      }

      &:last-of-type p {
        color: #4a4a4a;
      }

      .airalo-icon-wrapper {
        margin: 0 8px;

        [dir='rtl'] & {
          transform: rotateY(180deg);
        }
      }
    }
  }
</style>
